import email from '../assets/email.png';
import mobile from '../assets/mobile.png';
import css from '../assets/css.png';
import react from '../assets/react.png';
import blazor from '../assets/blazor.png';

import profile from '../assets/profile.png';
import circle from '../assets/circle.svg';
import logo from '../assets/logo.png';

export default {
  email,
  mobile,
  css,
  react,
  blazor,
  profile,
  circle, 
  logo
};